import { render, staticRenderFns } from "./Affiliation.vue?vue&type=template&id=691f8d77"
import script from "./Affiliation.vue?vue&type=script&lang=js"
export * from "./Affiliation.vue?vue&type=script&lang=js"
import style0 from "./Affiliation.vue?vue&type=style&index=0&id=691f8d77&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports